import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, CircularProgress, Box, Typography
} from '@mui/material';
import { gradientButtonSx, gradientTextSx } from '../../utils/colors';

const EMPTY_FORM = { fullName: '', rollNumber: '', email: '', leetcodeUsername: '' };

const AddStudentModal = ({ onClose, onSubmit, initialData = null }) => {
  const isEdit = Boolean(initialData);
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false); // ← was missing

  useEffect(() => {
    if (initialData) {
      setForm({
        fullName: initialData.fullName || '',
        rollNumber: initialData.rollNumber || '',
        email: initialData.email || '',
        leetcodeUsername: initialData.leetcodeUsername || '',
      });
    }
  }, [initialData]);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await onSubmit(form);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} disableEscapeKeyDown fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogTitle sx={{ fontWeight: 800, pb: 0 }}>
        <Typography variant="h6" fontWeight={800} sx={gradientTextSx}>
          {isEdit ? 'Edit Student' : 'Add Student'}
        </Typography>
      </DialogTitle>
      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <TextField
            label="Full Name" name="fullName" value={form.fullName} onChange={handleChange}
            placeholder="e.g. Rahul Sharma" fullWidth size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            label="Email" name="email" type="email" value={form.email}
            onChange={handleChange} placeholder="e.g. rahul@example.com"
            fullWidth size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            label="Roll Number" name="rollNumber" value={form.rollNumber}
            onChange={handleChange} placeholder="e.g. ROLL001" fullWidth size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            label="LeetCode Username" name="leetcodeUsername" value={form.leetcodeUsername}
            onChange={handleChange} placeholder="e.g. rahul_lc" fullWidth size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button onClick={onClose} sx={{ textTransform: 'none', borderRadius: 2 }}>
            Cancel
          </Button>
          <Button
            type="submit" variant="contained" disabled={submitting}
            sx={{ ...gradientButtonSx, px: 3 }}
          >
            {submitting ? <CircularProgress size={18} color="inherit" /> : (isEdit ? 'Save Changes' : 'Add Student')}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default AddStudentModal;
